import { SegmentOption } from './segment-option';

/**
 * Represents Donut Chart segment
 */
export class DonutChartSegment {
    /**
     * @type {string}
     */
    public currentProgress: string;
    /**
     * @type {SegmentOption}
     */
    public option: SegmentOption = null;

    /**
     * Constructor
     * @param {SegmentOption} segmentOption
     */
    public constructor(segmentOption: SegmentOption) {
        this.option = segmentOption;
        this.strokeProgress = this.option.percent;
    }

    /**
     * Returns the stroke offset. Used for the stroke-dashoffset property.
     * @returns {string}
     */
    public get strokeOffset(): string {
        return `${(this.computeCircumference() * this.option.initialOffset) / 100}`;
    }

    /**
     * Returns the stroke progress. Used for the stroke-dasharray property.
     * @returns {number}
     */
    public get strokeProgress(): number {
        return +this.currentProgress;
    }

    /**
     * Sets the segment current stroke
     * @param {number} value
     */
    public set strokeProgress(value: number) {
        const circumference = this.computeCircumference();
        this.currentProgress = `${(circumference * value) / 100} ${(circumference * (100 - value)) / 100}`;
    }

    /**
     * Compute the circumference of the circle
     * @returns {number}
     */
    private computeCircumference(): number {
        return 2 * Math.PI * this.option.radius;
    }
}
